import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EnumTranslatePipe } from '@shared/pipes';

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [
    EnumTranslatePipe
  ]
})
export class CoreModule { }
